import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 12000 });

export const STATUS_TONE = {
  draft: "default",
  scoped: "default",
  awaiting_cto_review: "warn",
  awaiting_authority_confirmation: "warn",
  approved_for_build: "signal",
  in_build: "signal",
  awaiting_test_evidence: "warn",
  release_ready: "success",
  released: "success",
  rejected: "danger",
  deferred: "warn",
  rollback_required: "danger",
};

export const STATUS_LABEL = {
  draft: "Draft",
  scoped: "Scoped",
  awaiting_cto_review: "Awaiting CTO review",
  awaiting_authority_confirmation: "Awaiting authority confirmation",
  approved_for_build: "Approved for build",
  in_build: "In build",
  awaiting_test_evidence: "Awaiting test evidence",
  release_ready: "Release ready",
  released: "Released",
  rejected: "Rejected",
  deferred: "Deferred",
  rollback_required: "Rollback required",
};

export const ACTIONS = [
  { value: "build_request_created", label: "Build request created", role: "Platform Sponsor" },
  { value: "scope_estimate_generated", label: "Scope estimate generated", role: "CTO" },
  { value: "dependency_map_confirmed", label: "Dependency map confirmed", role: "CTO" },
  { value: "budget_band_approved", label: "Budget band approved", role: "Platform Sponsor" },
  { value: "ai_task_plan_generated", label: "AI task plan generated (advisory)", role: "CTO" },
  { value: "developer_review_completed", label: "Developer review completed", role: "Developer 1" },
  { value: "dtool_build_evidence_attached", label: "dtool build evidence attached", role: "Delivery Operator" },
  { value: "test_evidence_attached", label: "Test evidence attached", role: "Test Reviewer" },
  { value: "release_readiness_approved", label: "Release readiness approved", role: "CTO" },
  { value: "deployment_completed", label: "Deployment completed", role: "Delivery Operator" },
  { value: "rollback_approved", label: "Rollback approved", role: "CTO" },
  { value: "out_of_band_decision_confirmed", label: "Out-of-band decision confirmed", role: "CTO" },
  { value: "delivery_receipt_signed", label: "Delivery receipt signed", role: "CTO" },
];

export const COMM_SOURCE_LABEL = {
  slack_thread_reference: "Slack thread reference",
  teams_thread_reference: "Teams thread reference",
  email_reference: "Email reference",
  meeting_note_reference: "Meeting note reference",
  incident_call_reference: "Incident call reference",
  client_call_reference: "Client call reference",
  other_reference: "Other reference",
};
